module.exports = __webpack_public_path__ + "img/permitirCamera.32c857d0.png";